function routeRegex(expression) {
  return new RegExp(
    `^/(${window.gon.availableLocales.join("|")})${expression}`,
    "i"
  )
}

export default routeRegex
